import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  useToast,
} from '@chakra-ui/react';
import apiClient from '../utils/apiClient';

const ImportDeviceExcelModalComponent = ({ isOpen, onClose, onSuccess }) => {
  const [file, setFile] = useState(null);
  const toast = useToast();

  const handleFileChange = event => {
    setFile(event.target.files[0]);
  };

  const handleSave = async () => {
    if (!file) {
      toast({
        title: 'Error',
        description: 'Please select an Excel file.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await apiClient.post(`/Device/importExcel`, formData, {
        responseType: 'blob', // Excel dosyasını indirmek için gerekli ayar
      });

      // Blob oluştur
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'imported_devices.xlsx'; // İndirilen dosyanın adı
      link.click();

      toast({
        title: 'Success',
        description: 'File imported and downloaded successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      onClose();
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Failed to import file:', error);
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Failed to import file.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Import Excel File</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input type="file" accept=".xlsx" onChange={handleFileChange} />
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={handleSave}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ImportDeviceExcelModalComponent;
